export default "__VITE_ASSET__M4__$YIf__"